import React, { Component } from 'react';
import { PayPalButton } from "react-paypal-button-v2";
import { MobileView, isMobile } from "react-device-detect";
import DCENJ from '../../Images/Inscripciones.jpg';
import LogoWhatsApp from '../../Images/WhatsApp.png';

export class PagoDiplomados extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientId: "ATtdy8yKssWx7tPmRM9dyDN9xXK3ZgJRVnOh1CoJxkax3ZAMIzPvn61HL-mRa4REqsQnV2kuvfsXPSQF",
            verPago: false,
            listo: false,
            nombre: "",
            apellidos: "",
            email: "",
            tel: "",
            carrera: "",
            id: "",
            enviando: false,
            guid: "",
            instrucciones: "captura tus datos para inscribirte, es necesario capturar todos los campos.",
            terminado: false,
            folio: ""
        };


        this.cambiarNombre = this.cambiarNombre.bind(this);
        this.cambiarApellidos = this.cambiarApellidos.bind(this);
        this.cambiarEmail = this.cambiarEmail.bind(this);
        this.cambiarTel = this.cambiarTel.bind(this);
        this.cambiarCarrera = this.cambiarCarrera.bind(this);
        this.revisarCambio = this.revisarCambio.bind(this);
        this.registrar = this.registrar.bind(this);
        this.guardarPaypal = this.guardarPaypal.bind(this);
        this.onApprove = this.onApprove.bind(this);
    }

    componentDidMount() {
    }

    cambiarNombre(event) {
        this.state.nombre = event.target.value;
        this.setState({ nombre: event.target.value });
        this.revisarCambio();
    }

    cambiarApellidos(event) {
        this.state.apellidos = event.target.value;
        this.setState({ apellidos: event.target.value });
        this.revisarCambio();
    }

    cambiarEmail(event) {
        this.state.email = event.target.value;
        this.setState({ email: event.target.value });
        this.revisarCambio();
    }

    cambiarTel(event) {
        this.state.tel = event.target.value;
        this.setState({ tel: event.target.value });
        this.revisarCambio();
    }

    cambiarCarrera(event) {
        this.state.carrera = event.target.value;
        this.setState({ carrera: event.target.value });
        this.revisarCambio();
    }

    revisarCambio() {
        var respuesta = true; 
        if (this.state.nombre == "") {
            respuesta = false;
        }
        if (this.state.apellidos == "") {
            respuesta = false;
        }
        if (this.state.tel == "") {
            respuesta = false;
        }
        if (this.state.email == "") {
            respuesta = false;
        }
        if (this.state.carrera == "") {
            respuesta = false;
        }
        if (this.state.id == "" && respuesta == true) {
            this.setState({listo: true})
        }
        return respuesta;
    }

    registrar() {   
        this.setState({ enviando: true });
        var xhr = new XMLHttpRequest();
        var principal = this;
        this.state.guid = this.props.getGuid();

        var sobre = { Guid: this.state.guid,  Carrera: this.state.carrera, Nombre: this.state.nombre, Apellidos: this.state.apellidos, Cel: this.state.tel, Email: this.state.email };
        xhr.open("POST", "api/Web/PaypalPaso1", true);

        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onload = function () {
            if (xhr.status === 200) {
                var id = xhr.responseText;
                principal.setState({ verPago: true, id: id, instrucciones: "selecciona tu método de pago" });
            }
            else {
                alert("No es posible contactar al servidor, revise su conexión a internet e intente de nuevo");
            }
        }
        xhr.onerror = () => {
            alert("No es posible contactar al servidor, revise su conexión a internet e intente de nuevo");
        }
        xhr.send(JSON.stringify(sobre));
    }

    guardarPaypal(datos) {
        this.setState({ enviando: true });
        var xhr = new XMLHttpRequest();
        var principal = this;

        var sobre = { Guid: this.state.guid, Carrera: this.state.carrera, Nombre: this.state.nombre, Apellidos: this.state.apellidos, Cel: this.state.tel, Email: this.state.email, id: this.state.id, paypal: datos };

        xhr.open("POST", "api/Web/PaypalPaso2", true);

        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onload = function () {
            if (xhr.status === 200) {
                var id = xhr.responseText;
                principal.setState({ terminado: true, folio: id });
            }
            else {

            }
        }
        
        xhr.send(JSON.stringify(sobre));
        alert("Su inscripción ha sido registrada, en breve nos pondremos en contacto con usted para darle la bienvenida e indicaciones, sobre el inicio del diplomado ");
    }
    onApprove(data, actions) {
        var principal = this;
        return actions.order.capture().then(function (details) {
            // Show a success message to your buyer
            //alert("Transaction completed by " + details.payer.name.given_name);
            var vals = JSON.stringify(data) + '|' + JSON.stringify(details)
            principal.guardarPaypal(vals);
        })
    }

    render() {
        return (
            <div >
                <div className="content">

                    <div className="ImgenCentral2" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
                        <img src={DCENJ} alt="Inscripciones" style={{ maxWidth: "450px" }} />
                    </div>
                    <div style={{ minWidth: "200px", maxWidth: "400px", margin: "auto", padding: "0px" }}>

                        {this.state.terminado ?
                            <div>
                                <h2>Tu inscripci&oacute;n ha quedado registrada </h2>
                                <br/>
                                Folio: <span> <strong>{this.state.folio}</strong></span>
                                <br />

                                Se ha asignado a un ejecutivo de admisiones, el cual se encargara de darte toda la informaci&oacute;n que necesites. 
                                <br />
                                <br />

                                 <ul style={{ width: "390px", margin: "auto" }}>
                                    <li>
                                        <strong>Ejecutivo:</strong> Jazmín Guadalupe Ayala
                                        </li>
                                    <li>
                                        <strong>Tel&eacute;fono:</strong> (462)6271789
                                            </li>
                                    <li>
                                        <strong>WhatsApp:</strong> +52 (462) 3403369
                                            <MobileView>
                                            <p>
                                                <a href='https://wa.me/524623403369' target="_blank"><img src={LogoWhatsApp} alt='llamar WhatsApp' style={{ width: "30px" }} /> Enviar mensaje ahora</a>
                                            </p>
                                        </MobileView>
                                    </li>
                                </ul>
                                <br />

                                <p>En breve pondremos en contacto contigo, para indicarte como acceder a la plataforma</p>
                                <br />
                                <br />

                            </div>

                            :

                            <div className="ListaInscripciones">
                                <h1 style={{ paddingTop: "20px", paddingBottom: "20px" }}> Formulario de Inscripci&oacute;n a Diplomados</h1>
                                <div>
                                    <p>
                                        <strong>Instrucciones: </strong> <span>{this.state.instrucciones}</span>
                                    </p>
                                </div>
                                {!this.state.verPago ?
                                    <ul className="Fuente2" style={{ listStyleType: "none", display: "inline" }}>
                                        <li>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            {this.state.enviando ?
                                                                <select value={this.state.carrera} onChange={this.cambiarCarrera} disabled>
                                                                    <option value="">Selecciona un diplomado</option>
                                                                    <option value="AUTI">Diplomado en inclusi&oacute;n de niños con Autismo</option>
                                                                    <option value="TDAH">Diplomado en inclusi&oacute;n de niños con TDAH</option>
                                                                    <option value="EAD">Dipl. Formaci&oacute;n de Profesores para el diseño e implementaci&oacute;n de Cursos en l&iacute;nea</option>
                                                                </select>
                                                                :
                                                                <select value={this.state.carrera} onChange={this.cambiarCarrera} >
                                                                    <option value="">Selecciona un diplomado</option>
                                                                    <option value="AUTI">Diplomado en inclusi&oacute;n de niños con Autismo</option>
                                                                    <option value="TDAH">Diplomado en inclusi&oacute;n de niños con TDAH</option>
                                                                    <option value="EAD">Dipl. Formaci&oacute;n de Profesores para el diseño e implementaci&oacute;n de Cursos en l&iacute;nea</option>
                                                                </select>

                                                            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </li>
                                        <li>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            Nombre
                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {this.state.enviando ?
                                                                <input value={this.state.nombre} onChange={this.cambiarNombre} disabled />
                                                                :
                                                                <input value={this.state.nombre} onChange={this.cambiarNombre} />
                                                            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </li>
                                        <li>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            Apellidos
                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {this.state.enviando ?
                                                                <input value={this.state.apellidos} onChange={this.cambiarApellidos} disabled />
                                                                :
                                                                <input value={this.state.apellidos} onChange={this.cambiarApellidos} />
                                                            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </li>
                                        <li>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            Correo electr&oacute;nico
                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {this.state.enviando ?
                                                                <input value={this.state.email} onChange={this.cambiarEmail} disabled />
                                                                :
                                                                <input value={this.state.email} onChange={this.cambiarEmail} />
                                                            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </li>
                                        <li>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            Tel&eacute;fono
                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {this.state.enviando ?
                                                                <input value={this.state.tel} onChange={this.cambiarTel} disabled />
                                                                :
                                                                <input value={this.state.tel} onChange={this.cambiarTel} />
                                                            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </li>

                                        <li>
                                            {this.state.listo && this.state.enviando == false ?
                                                <input value='Inscribirse' type='button' onClick={this.registrar} />
                                                :
                                                <input value='Inscribirse' type='button' disabled />

                                            }
                                        </li>
                                    </ul>
                                    : null}
                                {this.state.verPago ?
                                    <ul className="Fuente2" style={{ listStyleType: "none", display: "inline" }}>
                                        <li>
                                            <p>Selecciona tu método de pago</p>
                                            <p></p>
                                        </li>
                                        <li>
                                            <PayPalButton
                                                createOrder={(data, actions) => {
                                                    return actions.order.create({
                                                        purchase_units: [{
                                                            amount: {
                                                                value: "6000.00"
                                                            }
                                                        }],
                                                        // application_context: {
                                                        //   shipping_preference: "NO_SHIPPING" // default is "GET_FROM_FILE"
                                                        // }
                                                    });
                                                }}
                                                onApprove={this.onApprove}
                                                //(data, actions) => {
                                                // Capture the funds from the transaction
                                                //return actions.order.capture().then(function (details) {
                                                //    // Show a success message to your buyer
                                                //    //alert("Transaction completed by " + details.payer.name.given_name);
                                                //    var vals = JSON.stringify(data) + '|' + JSON.stringify(details)
                                                //    this.guardarPaypal(vals);
                                                // OPTIONAL: Call your server to save the transaction
                                                //return fetch("/paypal-transaction-complete", {
                                                //    method: "post",
                                                //    body: JSON.stringify({
                                                //        orderID: data.orderID
                                                //    })
                                                //});
                                                //}}
                                                options={{
                                                    clientId: this.state.clientId,
                                                    locale: "es_MX",
                                                    currency: "MXN"

                                                }}

                                            /></li>

                                    </ul>
                                    : null}
                            </div>
                        }

                    </div>
                </div>
            </div>
        );
    }
}
export default PagoDiplomados;


// WEBPACK FOOTER //
// ./src/components/Pagos/InscripcionDiplomados.js